import { NarrowLayout, WideLayout } from "source/Layout"

type FormWrapperProps = {
  authenticated: boolean
  children: NonNullable<React.ReactNode>
}

export function FormWrapper({
  authenticated = false,
  children,
}: FormWrapperProps) {
  const LayoutWrapper = authenticated ? WideLayout : NarrowLayout

  return (
    <LayoutWrapper>
      <div className="pc-donation-form d-f fd-c jc-c g-5 g-6@md mt-3@iframe p-3@iframe">
        {children}
      </div>
    </LayoutWrapper>
  )
}
